export const EVENT_LIST_TITLE_MAX_LEN = 255
export const EVENT_LIST_DESCRIPTION_MAX_LEN = 2000
